var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.showMissingModule
    ? _c(
        "w-card-content",
        [_c("app-missing-module", { attrs: { "module-id": _vm.moduleId } })],
        1
      )
    : _vm.isAllowed
    ? _c(
        "div",
        { staticClass: "root" },
        [
          _vm.toAddFiles.length != 0
            ? _c(
                "w-list",
                [
                  _c(
                    "w-list-item",
                    [
                      _c("w-list-item-text", [
                        _c("div", { staticClass: "sub-title" }, [
                          _vm._v(_vm._s(_vm.$ct("waiting-files"))),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _vm._l(_vm.toAddFiles, function (item, index) {
                    return _c(
                      "w-list-item",
                      { key: index },
                      [
                        _c(
                          "w-list-item-icon",
                          [_c("w-fa", { attrs: { icon: ["far", "file"] } })],
                          1
                        ),
                        _c("w-list-item-text", [_vm._v(_vm._s(item.name))]),
                        _c(
                          "w-list-item-action",
                          [
                            _c(
                              "w-button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.$ct("common.preview"),
                                    expression: "$ct('common.preview')",
                                  },
                                ],
                                on: {
                                  click: function ($event) {
                                    return _vm.openToUploadFilePreview(item)
                                  },
                                },
                              },
                              [_c("w-fa", { attrs: { icon: "eye" } })],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "w-list-item-action",
                          [
                            _c(
                              "w-button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.$ct("common.download"),
                                    expression: "$ct('common.download')",
                                  },
                                ],
                                on: {
                                  click: function ($event) {
                                    return _vm.downloadToUploadFile(item)
                                  },
                                },
                              },
                              [_c("w-fa", { attrs: { icon: "download" } })],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "w-list-item-action",
                          [
                            _c(
                              "w-button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.$ct("common.delete"),
                                    expression: "$ct('common.delete')",
                                  },
                                ],
                                staticClass: "danger",
                                on: {
                                  click: function ($event) {
                                    return _vm.removeToUploadFile(index)
                                  },
                                },
                              },
                              [_c("w-fa", { attrs: { icon: "trash" } })],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                ],
                2
              )
            : _vm._e(),
          _c(
            "w-card-content",
            [
              _c("app-file-upload", {
                attrs: { multiple: "", label: _vm.$ct("drop-your-images") },
                on: {
                  input: function ($event) {
                    return _vm.onFile($event)
                  },
                },
              }),
            ],
            1
          ),
          _vm.files.length > 0
            ? _c(
                "w-list",
                [
                  _c(
                    "w-list-item",
                    [
                      _c("w-list-item-text", [
                        _c("div", { staticClass: "sub-title" }, [
                          _vm._v(_vm._s(_vm.$ct("added-files"))),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _vm._l(_vm.files, function (item, i) {
                    return _c(
                      "w-list-item",
                      { key: item.ID },
                      [
                        _c(
                          "w-list-item-icon",
                          [_c("w-fa", { attrs: { icon: ["far", "file"] } })],
                          1
                        ),
                        _c("w-list-item-text", [
                          _vm._v(_vm._s(item.getName())),
                        ]),
                        _vm.allowMarkOriginal && item.canPreview()
                          ? _c(
                              "w-list-item-action",
                              [
                                _c(
                                  "w-button",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: item.IsOriginal
                                          ? _vm.$ct("is-original")
                                          : _vm.$ct("mark-original"),
                                        expression:
                                          "item.IsOriginal ? $ct('is-original') : $ct('mark-original')",
                                      },
                                    ],
                                    class: {
                                      "original-active": item.IsOriginal,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.markOriginal(item)
                                      },
                                    },
                                  },
                                  [
                                    _c("w-fa", {
                                      attrs: {
                                        icon: [
                                          item.IsOriginal ? "fas" : "far",
                                          "star",
                                        ],
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "w-list-item-action",
                          [
                            _c(
                              "w-button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.$ct("common.preview"),
                                    expression: "$ct('common.preview')",
                                  },
                                ],
                                attrs: { disabled: !item.canPreview() },
                                on: {
                                  click: function ($event) {
                                    return _vm.openPreview(item)
                                  },
                                },
                              },
                              [_c("w-fa", { attrs: { icon: "eye" } })],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "w-list-item-action",
                          [
                            _c(
                              "w-button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.$ct("common.download"),
                                    expression: "$ct('common.download')",
                                  },
                                ],
                                on: {
                                  click: function ($event) {
                                    return _vm.download(item)
                                  },
                                },
                              },
                              [_c("w-fa", { attrs: { icon: "download" } })],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "w-list-item-action",
                          [
                            _c(
                              "w-button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.$ct("common.delete"),
                                    expression: "$ct('common.delete')",
                                  },
                                ],
                                staticClass: "danger",
                                attrs: { danger: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeFile(i)
                                  },
                                },
                              },
                              [_c("w-fa", { attrs: { icon: "trash" } })],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                ],
                2
              )
            : _vm._e(),
          _c(
            "w-modal",
            {
              attrs: { value: _vm.showPreview },
              on: {
                input: function ($event) {
                  return _vm.closePreview()
                },
              },
            },
            [
              _c("app-preview", {
                attrs: {
                  file: _vm.previewFile,
                  "system-file": _vm.previewSystemFile,
                },
                on: {
                  close: function ($event) {
                    return _vm.closePreview()
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }